export default __webpack_public_path__ + "static/media/whats.e71f215e.svg";